/**
 * event.key doesn't work in IE11
 */
export function processKeyEvent({
    event,
    state,
    focusState,
    setState,
    nextTab,
    previousTab,
}) {
    // ArrowDown
    if (event.which === 40) {
        if (state.focusIndex < focusState.getItemCount() - 1) {
            const nextIndex = state.focusIndex + 1;
            setState({ focusIndex: nextIndex });
        }
    // ArrowUp
    } else if (event.which === 38) {
        if (state.focusIndex > 0) {
            const nextIndex = state.focusIndex - 1;
            setState({ focusIndex: nextIndex });
        }
    // ArrowLeft
    } else if (event.which === 37) {
        if (previousTab) {
            previousTab();
        }
    // ArrowRight
    } else if (event.which === 39) {
        if (nextTab) {
            nextTab();
        }
    // Enter
    } else if (event.which === 13) {
        const item = focusState.getItemAtIndex(state.focusIndex);
        if (item && item.click) {
            item.click();
        }
    }
}
